// extracted by mini-css-extract-plugin
export default {"mnNotificationRanking":"index_mnNotificationRanking__OcqA2","mnNotificationUnlock":"index_mnNotificationUnlock__Gmvj2"};